import { render, staticRenderFns } from "./VerifiyTradeRecord.vue?vue&type=template&id=7aa001cc&scoped=true&"
import script from "./VerifiyTradeRecord.vue?vue&type=script&lang=js&"
export * from "./VerifiyTradeRecord.vue?vue&type=script&lang=js&"
import style0 from "./VerifiyTradeRecord.vue?vue&type=style&index=0&id=7aa001cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa001cc",
  null
  
)

export default component.exports